import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-account-mini-card',
  templateUrl: './account-mini-card.component.html',
  styleUrls: ['./account-mini-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountMiniCardComponent {
  @Input() title = '';
  @Input() text?: string = '';
  @Input() icon?: string = '';
  @Input() color?: 'primary' | null = null;
  @Input() hideChevron = false;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter(); // we use "click" on purpose to get the click.observed in the template
}
